import Loader from "components/common/Loader";
import React, { Suspense } from "react";

type ReturnType<T> = (props: T) => JSX.Element;

export const withLoading = <T extends object>(
  Component: React.ComponentType<T>
): ReturnType<T> => {
  return (props: T) => (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};
